import { PlusIcon } from "@heroicons/react/24/outline";

const FloatingButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="fixed z-50 flex items-center justify-center w-12 h-12 text-2xl font-bold duration-300 rounded-full lg:bottom-6 bottom-4 lg:ltr:right-6 ltr:right-4 lg:rtl:left-6 rtl:left-2 lg:w-14 lg:h-14 dark:bg-primary bg-primary-light dark:text-bg-dark-primary text-bg-light-primary hover:opacity-90 shadow-glow hover:shadow-glow-hover"
        >
            <PlusIcon className="w-6 h-6 dark:text-bg-dark-primary text-bg-light-primary" />

        </button>
    );
};

export default FloatingButton;
